import styled, { keyframes } from "styled-components";

const rotate = keyframes`
  to{transform: rotate(1turn)}
`;

export const Spnr = styled.div`
    width:${p => p.width};
    height:${p => p.height};
    border-radius:50%;
    background:conic-gradient(#0000 10%, #0092ff);
    -webkit-mask:radial-gradient(farthest-side,#0000 calc(100% - ${p => p.borderWidth}),#000 0);
    animation: ${rotate} 1s infinite linear;
`;